/* libs */
import React, { Component } from "react";
import PropTypes from "prop-types";

/* components */
import formWrapper from "../../shared/Form";
import TextInput from "../../shared/Forms/TextInput";
import MultiSelect from "../../shared/Forms/MultiSelect";
import SelectInput from "../../shared/Forms/SelectInput";
import CheckBox from "../../shared/Forms/CheckBox";
import ChangeHistory from "../../shared/ChangeHistory";

/* helpers */
import { USER_ROLES } from "../../../constants";

class UserForm extends Component {
	/*
	- roles that the current user can assign to other users
	- user can only assign roles at a simlilar or lower level
	*/
	getAssignableRoles = role => {
		const labels = {
			master: "Master",
			full: "Full",
			structure: "Creator",
			content: "Editor",
		};
		const children = USER_ROLES.children[role];
		const options = children.map(child => ({
			key: child,
			value: child,
			label: labels[child],
		}));
		return options;
	};

	render() {
		const { experiences, user, values, buttonLabel, actionType, id } = this.props;
		const isGlobal = user && (user.globalRole ? true : false);
		const role = user && (isGlobal ? user.globalRole : user.role);
		const assignableRoles = user && this.getAssignableRoles(role);

		let roleDescription = null;
		switch (values.role) {
			case "master":
				roleDescription = "Highest level of permission to manage every part of your app";
				break;
			case "full":
				roleDescription = "Full permission to manage every part of your app";
				break;
			case "structure":
				roleDescription = "Can create and edit Pages, Themes, Posts, and Sessions";
				break;
			case "content":
				roleDescription = "Can edit existing Pages or create and edit Posts and Sessions";
				break;
			default:
				break;
		}

		return (
			<div>
				{actionType === "update" && !!id && <ChangeHistory id={id} entity="users" />}
				<TextInput isRequired field="firstName" id="firstName" placeholder="First Name" autoComplete="off" />
				<TextInput isRequired field="lastName" id="lastName" placeholder="Last Name" autoComplete="off" />
				<TextInput isRequired field="email" id="email" placeholder="Email" autoComplete="off" />
				{assignableRoles && (
					<SelectInput
						field="role"
						id="role"
						values={assignableRoles}
						placeholder="Roles"
						isRequired={true}
						helperText={roleDescription}
					/>
				)}
				{isGlobal && <CheckBox label="Global User" field="isGlobal" id="isGlobal" />}
				{experiences && experiences.length > 0 && (
					<MultiSelect
						field="experienceIds"
						label="Select the experiences the user is allowed to access"
						items={experiences}
						errorMessage="At least one experience is required"
						isRequired
					/>
				)}
				<div className="btn btn-success" onClick={() => this.props.submitForm(true)}>
					{buttonLabel}
				</div>
			</div>
		);
	}
}

UserForm.propTypes = {
	values: PropTypes.object,
	cultures: PropTypes.array,
	buttonLabel: PropTypes.string,
	showExtraFields: PropTypes.bool,
	experiences: PropTypes.object,
	user: PropTypes.object,
	id: PropTypes.string,
	actionType: PropTypes.string,
	submitForm: PropTypes.func,
};

export default formWrapper(UserForm);
